'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M0 400c0 61.9 50.1 112 112 112l376 0 24 0 0-24 0-176 0-24-24 0-102.1 0 79-79 17-17-17-17L337 47l-17-17L303 47l-79 79L224 24l0-24L200 0 24 0 0 0 0 24 0 400zm209.9 64l128-128L464 336l0 128-254.1 0zM414.1 192L224 382.1l0-188.1 96-96L414.1 192zM112 464c-35.3 0-64-28.7-64-64l0-96 128 0 0 96c0 35.3-28.7 64-64 64zM48 256l0-80 128 0 0 80L48 256zm0-128l0-80 128 0 0 80L48 128zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;